<template>
    <div class="companyInfo" v-if="list">
        <div class="fontSong12">公司名称：{{list.organ_name}}</div>
        <div class="fontSong12">注册时间：{{list.regiter_time}}</div>
        <div class="fontSong12" v-if="list.auth_num>0">信用认证：<span class="verdanF12">
            {{list.auth_num}}
        </span></div>
        <div class="fontSong12">
            特色业务：{{list.good_business}}</div>
        <div class="fontSong12">核心业务：{{list.core_business}}</div>
        <div class="fontSong12">所属地区：{{list.area}}</div>
        <template v-if="list.organ_name != '北京永乐国际拍卖有限公司'">
            <div class="pdt10">
            <div class="fontSong12">历史拍品：<span class="verdanF12">{{list.art_num}}</span></div>
            <div class="fontSong12">历史成交额：<span class="verdanF12">{{list.total_price}}</span></div>
        </div>
        </template>
       
        <!-- <div class="fontSong12 reaCode">微信公众号：
            <span class="codeMain"
                  @mousemove="mouseOver"
                  @mouseleave="mouseLeave"
            >鼠标移入查看二维码</span>
            <div class="qrCode" v-if="isQRCode" >
                <img class="codeImg" :src="list.miroblog_pic">
                <div>打开微信【扫一扫】</div>
                <div>扫描二维码</div>
            </div>
        </div> -->
    </div>
</template>

<script>
export default {
    name: "companyInfo",
    props: {
        list: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            isQRCode: false
        }
    },
    methods: {
        mouseOver() {
            this.isQRCode = true;
        },
        mouseLeave() {
            this.isQRCode = false;
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/auctionCompany.scss';
.companyInfo{
    color: #333;
    line-height: 22px;
    padding: 10px 0 2px 0;
    a{
        color:#333333;
    }
    .pdt10{
        padding: 10px 0 2px 0;
    }
}
.reaCode {
    position: relative;
    .codeMain {
        cursor: pointer;
        &:hover {
            color: rgba(13, 88, 172, 1);
        } 
    }
    .qrCode {
        position: absolute;
        text-align: center;
        width: 150px;
        height: 192px;
        color: rgba(102, 102, 102, 1);
        background-color: #fff;
        /* opacity: 0; */
        .codeImg {
            width: 130px;
            height: 130px;
        }
    }
}
</style>